import LocalizedFileInput from 'components/Erp/LocalizedFileInput';
import VehicleNumberInput from 'components/Forms/VehicleNumberInput/VehicleNumberInput.tsx';
import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { X, Plus } from 'lucide-react';
import React from 'react'
import styles from '../AdminPanelPage.module.scss'
import { uploadDriverDocuments } from '../../../service/AdminPanelService'

const CreateDriverForm = ({ employees = [], employeeSearch = '', setEmployeeSearch = () => {}, modalPayload = {}, setModalPayload = () => {}, closeModal = () => {}, createDriver, loadDriversByTopBase = async () => {}, notifySuccess = () => {}, notifyError = () => {} , topBases = [] , setTopBaseSearchByDriver = () => {}, topBaseSearchByDriver = {} }) => {
  useInterfaceLanguage();
  const [selectedFiles, setSelectedFiles] = React.useState([])
  const fileInputRef = React.useRef(null)

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || [])
    setSelectedFiles(prev => [...prev, ...files])
  }

  const removeFile = (index) => {
    setSelectedFiles(prev => prev.filter((_, i) => i !== index))
  }

  const handleCreate = async () => {
    try {
      const payload = { ...modalPayload }
      if (modalPayload.top_base_name) delete payload.top_base_name
      
      // Создаём водителя
      const result = await createDriver(payload)
      const driverId = result?.data?.id || result?.id
      
      // Загружаем документы, если есть
      if (selectedFiles.length > 0 && driverId) {
        try {
          await uploadDriverDocuments(driverId, selectedFiles)
        } catch (docErr) {
          console.error('Failed to upload documents:', docErr)
          notifyError(docErr, tr("Водитель создан, но не удалось загрузить документы"))
        }
      }
      
      if (payload.top_base) await loadDriversByTopBase(payload.top_base)
      closeModal()
      notifySuccess(tr("Водитель создан"))
    } catch (err) {
      console.error(err)
      notifyError(err, tr("Не удалось создать водителя"))
    }
  }

  return (
    <>
      <label>{tr("Сотрудник")}</label>
      <input
        placeholder={tr("Поиск сотрудника...")}
        value={employeeSearch}
        onChange={(e) => setEmployeeSearch(e.target.value)}
      />
      <select value={modalPayload.employee || ''} onChange={(e) => setModalPayload(p => ({ ...p, employee: Number(e.target.value) }))}>
        <option value="">{tr("— Выберите сотрудника —")}</option>
        {employees.filter(emp => (emp.label || '').toLowerCase().includes(employeeSearch.toLowerCase())).map(emp => (
          <option key={emp.id} value={emp.id}>{tr(emp.label)}</option>
        ))}
      </select>

      <label>{tr("ТОП-База")}</label>
      <input placeholder={tr("ТОП-База")} value={modalPayload.top_base_name || modalPayload.top_base || ''} readOnly />

      <label>{tr("Номер автомобиля")}</label>
      <VehicleNumberInput value={modalPayload.vehicle_number || ''} onChange={(e) => setModalPayload(p => ({ ...p, vehicle_number: e.target.value }))} />

      <label>{tr("Модель автомобиля")}</label>
      <input placeholder={tr("Модель машины")} value={modalPayload.vehicle_model || ''} onChange={(e) => setModalPayload(p => ({ ...p, vehicle_model: e.target.value }))} />
      
      <label>{tr("Документы")}</label>
      <LocalizedFileInput 
        type="file" 
        ref={fileInputRef}
        multiple 
        onChange={handleFileChange}
        style={{ marginBottom: '8px' }}
        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
      />
      {tr(selectedFiles.length > 0 && (
        <div style={{ marginBottom: '12px' }}>
          <strong>{tr("Выбрано файлов: ")}{tr(selectedFiles.length)}</strong>
          <ul style={{ margin: '8px 0', padding: '0 0 0 20px' }}>
            {selectedFiles.map((file, index) => (
              <li key={index} style={{ marginBottom: '4px' }}>
                {tr(file.name)} ({(file.size / 1024).toFixed(1)}{tr(" КБ)")}<button 
                  onClick={() => removeFile(index)}
                  style={{ marginLeft: '8px', padding: '2px 6px', fontSize: '12px' }}
                 aria-label={tr("Удалить выбранный файл")}><X size={14} aria-hidden="true"/></button>
              </li>
            ))}
          </ul>
        </div>
      ))}

      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => { closeModal() }} className={styles.btn_pin_close}><X size={14} aria-hidden="true"/>{tr(" Отмена")}</button>
        <button onClick={handleCreate} className={styles.btn_pin}><Plus size={14} aria-hidden="true"/>{tr(" Создать")}</button>
      </div>
    </>
  )
}

export default CreateDriverForm
